import { exportDataGrid  as excelExport } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { jsPDF } from 'jspdf';
import { exportDataGrid as pdfExport } from 'devextreme/pdf_exporter';
import { font } from './__fixtures__/font.js';

const onExporting = ({ format, component }) => {
    if (format === 'xlsx') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        excelExport({
            component,
            worksheet: worksheet
        }).then(function() {
            workbook.xlsx.writeBuffer()
                .then(function(buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream'}), 'DataGrid.xlsx');
                });
        });
    }

    if (format === 'pdf') {
        const doc = new jsPDF();
        doc.addFileToVFS("font.ttf", font);
        doc.addFont("font.ttf", "font", "normal");
        doc.setFont("font");

        pdfExport({
            jsPDFDocument: doc,
            component,
        }).then(() => {
            doc.save('data.pdf');
        });
    }
    
};

export default onExporting;